/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  /* Base ":host" styles for the component */
  box-sizing: border-box;
  background-color: var(--calcite-color-foreground-1);
  color: var(--calcite-color-text-2);
  font-size: var(--calcite-font-size--1);
}
:host * {
  box-sizing: border-box;
}

:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-panel-content-space: Specifies the padding of the component's content.
* @prop --calcite-panel-footer-padding: Specifies the padding of the component's footer.
* @prop --calcite-panel-header-border-block-end: Specifies the component header's block end border.
* @prop --calcite-panel-background-color: Specifies the background color of the component.
*/
:host {
  position: relative;
  display: flex;
  block-size: 100%;
  inline-size: 100%;
  flex: 1 1 auto;
  overflow: hidden;
  --calcite-min-header-height: calc(var(--calcite-icon-size) * 3);
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

/* Shared styles for header elements */
.header {
  margin: 0px;
  display: flex;
  align-content: space-between;
  align-items: center;
  fill: var(--calcite-color-text-2);
  color: var(--calcite-color-text-2);
}

.heading {
  margin: 0px;
  padding: 0px;
  font-weight: var(--calcite-font-weight-medium);
}

.header .heading {
  flex: 1 1 auto;
  padding: 0.5rem;
}

:host([scale=s]) {
  --calcite-internal-panel-default-padding: var(--calcite-spacing-sm);
  --calcite-internal-panel-header-vertical-padding: 10px;
}
:host([scale=s]) .header-content .heading {
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
}
:host([scale=s]) .header-content .description {
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
}

:host([scale=m]) {
  --calcite-internal-panel-default-padding: var(--calcite-spacing-md);
  --calcite-internal-panel-header-vertical-padding: var(--calcite-spacing-lg);
}
:host([scale=m]) .header-content .heading {
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
}
:host([scale=m]) .header-content .description {
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
}

:host([scale=l]) {
  --calcite-internal-panel-default-padding: var(--calcite-spacing-xl);
  --calcite-internal-panel-header-vertical-padding: var(--calcite-spacing-xxl);
}
:host([scale=l]) .header-content .heading {
  font-size: var(--calcite-font-size-1);
  line-height: 1.5rem;
}
:host([scale=l]) .header-content .description {
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
}

.content-top,
.content-bottom {
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  border-block-start: 1px solid var(--calcite-color-border-3);
  background-color: var(--calcite-color-foreground-1);
}

.container {
  position: relative;
  margin: 0px;
  display: flex;
  inline-size: 100%;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: stretch;
  background-color: var(--calcite-color-background);
  padding: 0px;
  transition: max-block-size var(--calcite-animation-timing), inline-size var(--calcite-animation-timing);
}

.container[hidden] {
  display: none;
}

.header {
  z-index: var(--calcite-z-index-header);
  display: flex;
  flex-direction: column;
  background-color: var(--calcite-color-foreground-1);
  border-block-end: var(--calcite-panel-header-border-block-end, 1px solid var(--calcite-color-border-3));
}

.header-container {
  display: flex;
  inline-size: 100%;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  flex: 0 0 auto;
}

.header-container--border-end {
  border-block-end: 1px solid var(--calcite-color-border-3);
}

.action-bar-container {
  inline-size: 100%;
}

.action-bar-container ::slotted(calcite-action-bar) {
  inline-size: 100%;
}

.header-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-inline: 0.75rem;
  padding-block: 0.875rem;
  margin-inline-end: auto;
}
.header-content .heading,
.header-content .description {
  display: block;
  overflow-wrap: break-word;
  padding: 0px;
}
.header-content .heading {
  margin-inline: 0px;
  margin-block: 0px 0.25rem;
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-1);
}
.header-content .heading:only-child {
  margin-block-end: 0px;
}
.header-content .description {
  color: var(--calcite-color-text-2);
}

.back-button {
  border-width: 0px;
  border-style: solid;
  border-color: var(--calcite-color-border-3);
  border-inline-end-width: 1px;
}

.header-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
}

.header-actions--end {
  margin-inline-start: auto;
}

.content-wrapper {
  display: flex;
  block-size: 100%;
  flex: 1 1 auto;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  overflow: auto;
  outline-color: transparent;
  padding: var(--calcite-panel-content-space, 0);
  background: var(--calcite-panel-background-color, var(--calcite-color-background));
}

.content-wrapper:focus-visible {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

.content-top,
.content-bottom {
  padding: var(--calcite-internal-panel-default-padding);
}

.header-content {
  flex: 1 1 auto;
  padding-block: var(--calcite-internal-panel-header-vertical-padding);
  padding-inline: var(--calcite-internal-panel-default-padding);
}

.footer {
  margin-block-start: auto;
  display: flex;
  flex-direction: row;
  align-content: space-between;
  align-items: center;
  justify-content: center;
  background-color: var(--calcite-color-foreground-1);
  font-size: var(--calcite-font-size--2);
  line-height: 1.375;
  border-block-start: 1px solid var(--calcite-color-border-3);
  padding: var(--calcite-panel-footer-padding, var(--calcite-internal-panel-default-padding));
}

.footer-content {
  display: flex;
  flex: 1 1 0%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.footer-actions {
  display: flex;
  flex: 1 1 0%;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  gap: var(--calcite-internal-panel-default-padding);
}

.footer-start {
  display: flex;
  flex: 1 1 0%;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-inline-end: auto;
  gap: var(--calcite-internal-panel-default-padding);
}

.footer-end {
  display: flex;
  flex: 1 1 0%;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-inline-start: auto;
  gap: var(--calcite-internal-panel-default-padding);
}

.fab-container {
  position: sticky;
  inset-block-end: 0px;
  z-index: var(--calcite-z-index-sticky);
  margin-block: 0px;
  margin-inline: auto;
  display: block;
  padding: 0.5rem;
  inset-inline: 0;
  inline-size: -moz-fit-content;
  inline-size: fit-content;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}